import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

// import { isFuncComp } from '../../../../components/common/Helpers';

// const shippingHeader = Loadable(() => (!isFuncComp() ? import('../../containers/web/shippingHeader') : import('../../containers/shippingHeader')));

const shippingHeader = Loadable(() => import('../../containers/shippingHeader'));

export default MapTo('vcg/components/soe-home/react/shippingHeading')(shippingHeader);
